export default {"src":"/_next/static/image/public/assets/whatsapp.7084f23875055dc367dd3d0dd212c91a.svg","height":31,"width":30};